module.exports = __webpack_public_path__ + "img/brushes-en-hero.0412933.jpg";